var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import Plugin, { Events, Util, POSITIONS, Sniffer, STATE_CLASS } from '../../plugin';

var Controls = function (_Plugin) {
  _inherits(Controls, _Plugin);

  function Controls() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Controls);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Controls.__proto__ || Object.getPrototypeOf(Controls)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseEnter = function (e) {
      var _this2 = _this,
          player = _this2.player;

      if (player.userTimer) {
        clearTimeout(player.userTimer);
      }
    }, _this.onMouseLeave = function () {
      var _this3 = _this,
          player = _this3.player,
          playerConfig = _this3.playerConfig;

      if (!playerConfig.closeControlsBlur) {
        player.emit(Events.PLAYER_FOCUS);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Controls, [{
    key: 'beforeCreate',
    value: function beforeCreate(args) {
      if (typeof args.player.config.controls === 'boolean') {
        args.config.disable = !args.player.config.controls;
      }
      if (!args.config.mode && Sniffer.device === 'mobile') {
        args.config.mode = 'flex';
      }
      if (args.player.config.marginControls) {
        args.config.autoHide = false;
      }
    }
  }, {
    key: 'afterCreate',
    value: function afterCreate() {
      var _this4 = this;

      var _config = this.config,
          disable = _config.disable,
          height = _config.height,
          mode = _config.mode,
          autoHide = _config.autoHide;

      if (disable) {
        return;
      }

      mode === 'flex' && this.player.addClass(STATE_CLASS.FLEX_CONTROLS);
      autoHide && this.player.addClass(STATE_CLASS.AUTOHIDE);
      var style = {
        height: height + 'px'
      };
      Object.keys(style).map(function (key) {
        _this4.root.style[key] = style[key];
      });
      this.left = this.find('xg-left-grid');
      this.center = this.find('xg-center-grid');
      this.right = this.find('xg-right-grid');
      this.innerRoot = this.find('xg-inner-controls');

      // 切换为小窗状态的时候进度条同步切换
      this.on(Events.MINI_STATE_CHANGE, function (isMini) {
        isMini ? Util.addClass(_this4.root, 'mini-controls') : Util.removeClass(_this4.root, 'mini-controls');
      });
      if (Sniffer.device !== 'mobile') {
        this.bind('mouseenter', this.onMouseEnter);
        this.bind('mouseleave', this.onMouseLeave);
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.player.emit(Events.PLAYER_FOCUS, { autoHide: false });
    }
  }, {
    key: 'unFocus',
    value: function unFocus() {
      this.player.emit(Events.PLAYER_FOCUS, { autoHide: true });
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.player.emit(Events.PLAYER_BLUR, { ignoreStatus: true });
    }
  }, {
    key: 'recoverAutoHide',
    value: function recoverAutoHide() {
      this.config.autoHide && Util.addClass(this.root, 'control_autohide');
    }
  }, {
    key: 'pauseAutoHide',
    value: function pauseAutoHide() {
      Util.removeClass(this.root, 'control_autohide');
    }
  }, {
    key: 'show',
    value: function show() {
      Util.addClass(this.root, 'show');
    }
  }, {
    key: 'hide',
    value: function hide() {
      Util.removeClass(this.root, 'show');
    }
  }, {
    key: 'registerPlugin',
    value: function registerPlugin(plugin) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var name = arguments[2];

      if (!this.root) {
        return;
      }
      var defaultConfig = plugin.defaultConfig || {};
      if (!options.root) {
        var position = options.position ? options.position : options.config && options.config.position ? options.config.position : defaultConfig.position;
        switch (position) {
          case POSITIONS.CONTROLS_LEFT:
            options.root = this.left;
            break;
          case POSITIONS.CONTROLS_RIGHT:
            options.root = this.right;
            break;
          case POSITIONS.CONTROLS_CENTER:
            options.root = this.center;
            break;
          case POSITIONS.CONTROLS:
            options.root = this.root;
            break;
          default:
            options.root = this.left;
        }
        return _get(Controls.prototype.__proto__ || Object.getPrototypeOf(Controls.prototype), 'registerPlugin', this).call(this, plugin, options, name);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (Sniffer.device === 'mobile') {
        this.unbind('mouseenter', this.onMouseEnter);
        this.unbind('mouseleave', this.onMouseLeave);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.config.disable) {
        return;
      }
      var className = this.config.mode === 'flex' ? 'flex-controls ' : '';
      className += this.config.autoHide ? 'control_autohide' : 'controls_permanent xgplayer-controls-initshow';
      className += this.config.initShow ? ' xgplayer-controls-initshow' : '';
      return '<xg-controls class="xgplayer-controls ' + className + '" unselectable="on" onselectstart="return false">\n    <xg-inner-controls class="xg-inner-controls xg-pos">\n      <xg-left-grid class="xg-left-grid">\n      </xg-left-grid>\n      <xg-center-grid class="xg-center-grid"></xg-center-grid>\n      <xg-right-grid class="xg-right-grid">\n      </xg-right-grid>\n    </xg-inner-controls>\n    </xg-controls>';
    }
  }, {
    key: 'mode',
    get: function get() {
      return this.config.mode;
    }
  }], [{
    key: 'pluginName',
    get: function get() {
      return 'controls';
    }
  }, {
    key: 'defaultConfig',
    get: function get() {
      return {
        disable: false,
        autoHide: true, // 是否自动隐藏
        mode: '', // 显示模式， flex和normal
        initShow: false // 是否初始化的时候就显示
      };
    }
  }]);

  return Controls;
}(Plugin);

export default Controls;